import React, { useCallback, useState, useEffect } from "react";
import {
  Button,
  Table,
  Pagination,
  Modal,
  Form,
  Select,
  Input,
  Upload,
  message,
  AutoComplete,
} from "antd";
import type { ColumnsType } from "antd/es/table";
import { store } from "@root/store/index";
import { PlusOutlined } from "@ant-design/icons";
import {
  getHelpRelation,
  getHelpRelat,
  getHospitalBatch,
  addHelpRelation,
  setAdjustSubmit,
  setHelpRelation,
  getThreeInstitute,
} from "@root/common/service";
import axios from "axios";
import "../_index.scss";
const { Option } = Select;

interface DataType {
  key: number | string;
  auditStatus: number | string; // 国家审核状态 0审核通过  1- 2待审核
  confirmStatus: number | string; // 支援医院确认状态 0通过 1拒绝 2未确认
  adjustType: string; // 调整类型 0新增帮扶 1解除帮扶
  submitStatus: number | string; // 上报状态
  year: number | string; // 年度
  batchNumber: number | string; // 批次
  recipientInstituteName: string; // 三级医院名称
  subjectId: number | string; // 学科
  supportInstituteName: string; // 支援医院名称
}
function HelpRelation() {
  const columns: ColumnsType<DataType> = [
    {
      title: "调整类型",
      dataIndex: "adjustType",
      key: "adjustType",
      width: 80,
      render: (_, a) => (
        <>
          {(() => {
            if (a.adjustType === "0") {
              return (
                <span
                  style={{
                    color: "#fff",
                    backgroundColor: "#2a82e4",
                    padding: "3px",
                    borderRadius: "11px",
                  }}
                >
                  新增帮扶
                </span>
              );
            } else {
              return (
                <span
                  style={{
                    color: "#fff",
                    backgroundColor: "#ff8d1a",
                    padding: "3px",
                    borderRadius: "11px",
                  }}
                >
                  解除帮扶
                </span>
              );
            }
          })()}
        </>
      ),
    },
    {
      title: "上报状态",
      dataIndex: "submitStatus",
      key: "submitStatus",
      width: 80,
      render: (_, a) => (
        <>
          {(() => {
            if (a.submitStatus === 0) {
              return <span style={{ color: "#ff8d1a" }}>未上报</span>;
            } else if (a.submitStatus === 1) {
              return <span style={{ color: "#2a82e4" }}>已上报</span>;
            }
          })()}
        </>
      ),
    },
    {
      title: "国家审核状态",
      dataIndex: "auditStatus",
      key: "auditStatus",
      width: 80,
      render: (_, a) => (
        <>
          {(() => {
            if (a.confirmStatus === "1") {
              return <span style={{ color: "#ff5733" }}>-</span>;
            } else if (a.auditStatus === "2") {
              return <span style={{ color: "#ff8d1a" }}>待审核</span>;
            } else if (a.auditStatus === "1") {
              return <span style={{ color: "red" }}>审核退回</span>;
            } else if (a.auditStatus === "0") {
              return <span style={{ color: "#43cf7c" }}>审核通过</span>;
            }
          })()}
        </>
      ),
    },
    {
      title: "支援医院确认状态",
      dataIndex: "confirmStatus",
      key: "confirmStatus",
      width: 80,
      render: (_, a) => (
        <>
          {(() => {
            if (a.confirmStatus === "0") {
              return <span style={{ color: "#2a82e4" }}>通过</span>;
            } else if (a.confirmStatus === "2") {
              return <span style={{ color: "#ff8d1a" }}>未确认</span>;
            } else {
              return <span style={{ color: "#ff5733" }}>拒绝</span>;
            }
          })()}
        </>
      ),
    },
    {
      title: "年度",
      dataIndex: "year",
      key: "year",
      width: 50,
    },
    {
      title: "批次",
      dataIndex: "batchNumber",
      key: "batchNumber",
      width: 30,
    },
    {
      title: "县医院名称",
      dataIndex: "recipientInstituteName",
      key: "recipientInstituteName",
    },
    {
      title: "对应学科",
      dataIndex: "subjectId",
      key: "subjectId",
      width: 100,
      render: (_, a) => (
        <>
          {(() => {
            let subject: any = "";
            subjectIdArr.forEach((e: any) => {
              if (a.subjectId === parseFloat(e.id)) {
                subject = e.name;
                return;
              }
            });
            return <span>{subject}</span>;
          })()}
        </>
      ),
    },
    {
      title: "三级医院名称",
      dataIndex: "supportInstituteName",
      key: "supportInstituteName",
    },
    {
      title: "操作",
      dataIndex: "set",
      key: "set",
      width: 50,
      render: (_, e) => (
        <Button
          style={{ padding: "0" }}
          onClick={() => setObject(e)}
          type="link"
        >
          编辑
        </Button>
      ),
    },
  ];
  const columnsDel: ColumnsType<DataType> = [
    {
      title: "县医院名称",
      dataIndex: "recipientInstituteName",
      key: "recipientInstituteName",
    },
    {
      title: "对应学科",
      dataIndex: "subjectId",
      key: "subjectId",
      render: (_, a) => (
        <>
          {(() => {
            let subject: any = "";
            subjectIdArr.forEach((e: any) => {
              if (a.subjectId === parseFloat(e.id)) {
                subject = e.name;
                return;
              }
            });
            return <span>{subject}</span>;
          })()}
        </>
      ),
    },
    {
      title: "支援医院名称",
      dataIndex: "supportInstituteName",
      key: "supportInstituteName",
    },
    {
      title: "帮扶状态",
      dataIndex: "confirmStatus",
      key: "confirmStatus",
      render: (_, a) => <span>帮扶中</span>,
    },
    {
      title: "解除帮扶",
      dataIndex: "set",
      key: "set",
      render: (_, e) => (
        <Button
          style={{ padding: "0" }}
          onClick={() => delHelpRelation(e)}
          type="link"
        >
          解除帮扶
        </Button>
      ),
    },
  ];
  const [form] = Form.useForm();
  const [data, setData] = useState<DataType[]>();
  const [dataDel, setDataDel] = useState<DataType[]>();
  // const [current, setCurrent] = useState(1);
  const [subjectIdArr, setSubjectIdArr] = useState<any>([]);
  // const [total, setTotal] = useState<number>()
  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
  const [isAddHelp, setIsAddHelp] = useState(false);
  const [isEditHelp, setIsEditHelp] = useState(false);
  const [isDelHelp, setIsDelHelp] = useState(false);
  const [nowYear, setNowYear] = useState<number>();
  const [batch, setBatch] = useState<number>();
  const [fileList, setFileList] = useState<any>([]);
  const [batchObj, setBatchObj] = useState<any>({});
  const [instituteId, setInstituteId] = useState<any>([]);
  const [shortUrl, setShortUrl] = useState("");
  const [options, setOptions] = useState<
    { value: string; id: number | string }[]
  >([]);
  const [supportInstituteId, setSupportInstituteId] = useState("");
  const [objItem, setObjItem] = useState({
    year: 2022,
    batch: 1,
    subjectId: 1,
    name: "",
    files: "",
  });
  const [editAll, setEditAll] = useState<any>();
  const [fileKey, setFileKey] = useState<any>(0);

  const getBatch = async () => {
    const { data: a } = await getHospitalBatch({
      instituteId: store.getState().userInfo.instituteId,
    });
    console.log(a);
    setNowYear(a.year);
    setBatch(a.batchNumber);
    setBatchObj(a);
  };

  const getAll = async () => {
    const { rows } = await getHelpRelation(
      `recipientInstituteId=${store.getState().userInfo.instituteId}&type=1`
    );
    rows.forEach((e: any) => {
      e.key = e.id;
    });
    setData(rows);
  };
  const getThree = async () => {
    const { rows } = await getThreeInstitute();
    const data = rows.map((e: any) => {
      return {
        key: e.id,
        id: e.id,
        // name: e.name,
        value: e.name,
      };
    });
    setInstituteId(data);
  };

  useEffect(() => {
    console.log(store.getState());
    const subject = JSON.parse(
      JSON.stringify(store.getState().directionaries.subjectData)
    );
    subject.forEach((e: any) => {
      e.id = e.id.toString();
    });
    setSubjectIdArr(subject);
    getBatch();
    getAll();
    getThree();
  }, []);

  const setObject = useCallback(
    (e: any) => {
      console.log(e, fileList);
      setEditAll(e);
      setShortUrl("");
      setObjItem({
        year: e.year,
        batch: e.batchNumber,
        subjectId: e.subjectId.toString(),
        name: e.supportInstituteName,
        files: e.fileUrl,
      });
      form.setFieldsValue({
        year: e.year,
        batch: e.batchNumber,
        subjectId: e.subjectId.toString(),
        name: e.supportInstituteName,
        files: e.fileUrl,
      });
      setIsEditHelp(true);
    },
    [form, fileList]
  );
  // console.log(fileList);

  const addHelp = useCallback((e: any) => {
    console.log(e);
    setIsAddHelp(true);
  }, []);

  const delHelp = useCallback(
    (e: any) => {
      console.log(e);
      const getDel = async () => {
        const { rows } = await getHelpRelat({
          recipientInstituteId: batchObj.instituteId,
        });
        rows.forEach((el: any) => {
          el.key = el.id;
        });
        setDataDel(rows);
      };
      getDel();
      setIsDelHelp(true);
    },
    [batchObj]
  );
  const delHelpRelation = useCallback(
    (e: any) => {
      console.log(e);
      const delOne = async () => {
        const { code } = await addHelpRelation({
          recipientInstituteId: e.recipientInstituteId, // 县医院 受援医院
          supportInstituteId: e.supportInstituteId, // 三级医院 支援医院
          subjectId: e.subjectId,
          adjustType: 1,
          fileUrl: "",
          batchId: e.batchId,
          hospitalBatchId: batchObj.id,
          // batchId: (batchObj.batchId).toString(),
          // hospitalBatchId: (batchObj.id).toString()
        });
        if (code === 200) {
          message.success("解除帮扶成功");
          getAll();
          setIsDelHelp(false);
        }
      };
      delOne();
    },
    [batchObj]
  );
  const handleCancel = useCallback((e: any) => {
    console.log(e);
    setIsAddHelp(false);
  }, []);

  const onSearch = (searchText: string) => {
    const arr: any = [];
    instituteId.forEach((e: any) => {
      if (JSON.stringify(e).indexOf(searchText) >= 0) {
        arr.push(e);
      }
    });
    setOptions(arr);
  };

  const onSelect = (data: string, e: any) => {
    console.log("onSelect", data, e);
    setSupportInstituteId(e.id);
  };

  const start = (e: boolean) => {
    // setLoading(true);
    const setSubmint = async () => {
      const { code, msg } = await setAdjustSubmit({
        ids: selectedRowKeys.join(),
        status: e,
      });
      if (code === 200) {
        message.success(`${msg}`);
        getAll();
      } else {
        message.error(`${msg}`);
      }
    };
    setSubmint();
  };
  const onFinish = useCallback(
    (e: any) => {
      console.log(e);
      const addOne = async () => {
        const { code } = await addHelpRelation({
          recipientInstituteId: batchObj.instituteId, // 县医院 受援医院
          supportInstituteId: supportInstituteId, // 三级医院 支援医院
          subjectId: e.subjectId,
          adjustType: 0,
          fileUrl: shortUrl,
          batchId: batchObj.batchId,
          hospitalBatchId: batchObj.id,
          // batchId: (batchObj.batchId).toString(),
          // hospitalBatchId: (batchObj.id).toString()
        });
        if (code === 200) {
          message.success("新增成功");
          getAll();
          setIsAddHelp(false);
        }
      };
      addOne();
    },
    [batchObj, shortUrl, supportInstituteId]
  );
  const onFinishEdit = useCallback(
    (e: any) => {
      console.log(e, editAll, supportInstituteId, shortUrl);
      const editOne = async () => {
        const { code } = await setHelpRelation({
          recipientInstituteId: editAll.recipientInstituteId,
          supportInstituteId:
            supportInstituteId === ""
              ? editAll.supportInstituteId
              : supportInstituteId,
          subjectId: e.subjectId,
          fileUrl: shortUrl === "" ? editAll.shortUrl : shortUrl,
          id: editAll.id,
        });
        if (code === 200) {
          message.success("编辑成功");
          getAll();
          setIsEditHelp(false);
        }
      };
      editOne();
    },
    [editAll, supportInstituteId, shortUrl]
  );

  const onFinishFailed = useCallback((e: any) => {
    console.log(e);
  }, []);
  const handleChange = useCallback((e: any) => {
    console.log(e);
  }, []);
  const onSelectChange = (newSelectedRowKeys: React.Key[]) => {
    setSelectedRowKeys(newSelectedRowKeys);
  };
  // console.log('selectedRowKeys changed: ', selectedRowKeys);
  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };
  const hasSelected = selectedRowKeys.length > 0;

  return (
    <div>
      <div className="midBtn1">
        <Button type="primary" onClick={addHelp}>
          新增帮扶
        </Button>
        <Button danger type="primary" onClick={delHelp}>
          解除帮扶
        </Button>
        <Button
          type="primary"
          onClick={() => start(true)}
          disabled={!hasSelected}
        >
          确认上报
        </Button>
        <Button
          danger
          type="primary"
          onClick={() => start(false)}
          disabled={!hasSelected}
        >
          取消上报
        </Button>
      </div>

      <div>
        <Table
          bordered
          size="middle"
          rowSelection={rowSelection}
          columns={columns}
          dataSource={data}
        />
        {/* <Table bordered size='middle' pagination={false} rowSelection={rowSelection} columns={columns} dataSource={data} /> */}
        {/* <Pagination style={{margin: '10px 0',float: 'right'}} current={current} onChange={onChange} total={total} showSizeChanger={false}/> */}
      </div>

      <Modal
        title="新增帮扶关系"
        visible={isAddHelp}
        onCancel={handleCancel}
        footer={[]}
      >
        <Form
          name="addHelp"
          initialValues={{ remember: true }}
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          autoComplete="off"
        >
          <Form.Item
            label="年度"
            name="year"
            rules={[{ required: true, message: "年度不可为空，请正确选择!" }]}
          >
            <Select placeholder="请选择年度" onChange={handleChange} allowClear>
              <Option value={nowYear}>{nowYear}</Option>
            </Select>
          </Form.Item>

          <Form.Item
            label="批次"
            name="batch"
            rules={[{ required: true, message: "批次不可为空，请正确选择!" }]}
          >
            <Select placeholder="请选择批次" onChange={handleChange} allowClear>
              <Option value={batch}>{batch}</Option>
            </Select>
          </Form.Item>

          <Form.Item
            label="选择学科"
            name="subjectId"
            rules={[{ required: true, message: "学科不可为空，请正确选择!" }]}
          >
            <Select
              placeholder="请选择学科"
              onChange={handleChange}
              allowClear
              style={{ width: 120 }}
            >
              {subjectIdArr.map((e: any, i: number) => {
                return (
                  <Option value={e.id} key={i}>
                    {e.name}
                  </Option>
                );
              })}
            </Select>
          </Form.Item>

          <Form.Item
            label="三级医院名称"
            name="name"
            rules={[
              { required: true, message: "医院名称不可为空，请正确选择!" },
            ]}
          >
            {/* <Input placeholder="请输入医院名称" /> */}
            <AutoComplete
              options={options}
              // style={{ width: 200 }}
              onSelect={onSelect}
              onSearch={onSearch}
              placeholder="请输入医院名称"
            />
          </Form.Item>

          <Form.Item label="上传附件" valuePropName="files">
            <Upload
              listType="picture-card"
              maxCount={1}
              accept=".pdf"
              onRemove={(file) => {
                const index = fileList.indexOf(file);
                const newFileList = fileList.slice();
                newFileList.splice(index, 1);
                setFileList(newFileList);
              }}
              beforeUpload={(file) => {
                console.log(file);
                if (file.size > 307200) {
                  message.error("文件不可大于300K");
                  return;
                }
                const formData = new FormData();
                formData.append("file", file);
                setFileList([...fileList, file]);
                const {
                  userInfo: { access_token },
                } = store.getState();
                const config = {
                  headers: {
                    "Content-Type": "multipart/form-data",
                    Authorization: `Bearer ${access_token}`,
                  },
                };
                axios
                  .post(
                    `/dev-api/file/oss/uploadFile?uploadFileType=file&folder=sys`,
                    formData,
                    config
                  )
                  .then(
                    (res: any) => {
                      console.log(res.data.data.shortUrl);
                      setShortUrl(res.data.data.shortUrl);
                    },
                    (err) => {
                      message.error(`${err}`);
                    }
                  );
                return false;
              }}
            >
              <div>
                <PlusOutlined />
              </div>
            </Upload>
            注：仅限上传pdf格式文件，大小不大于300k 。
          </Form.Item>

          <Form.Item wrapperCol={{ offset: 8, span: 16 }}>
            <Button style={{ marginRight: "15px" }} onClick={handleCancel}>
              取消
            </Button>
            <Button type="primary" htmlType="submit">
              保存
            </Button>
          </Form.Item>
        </Form>
      </Modal>

      <Modal
        title="编辑帮扶关系"
        visible={isEditHelp}
        onCancel={() => {
          setFileKey(fileKey + 1);
          setIsEditHelp(false);
        }}
        footer={[]}
      >
        <Form
          name="editHelp"
          form={form}
          onFinish={onFinishEdit}
          onFinishFailed={onFinishFailed}
          autoComplete="off"
          initialValues={{
            year: objItem.year,
            batch: objItem.batch,
            subjectId: objItem.subjectId.toString(),
            name: objItem.name,
            files: objItem.files,
          }}
        >
          <Form.Item
            label="年度"
            name="year"
            rules={[{ required: true, message: "年度不可为空，请正确选择!" }]}
          >
            <Input disabled />
          </Form.Item>

          <Form.Item
            label="批次"
            name="batch"
            rules={[{ required: true, message: "批次不可为空，请正确选择!" }]}
          >
            <Input disabled />
          </Form.Item>

          <Form.Item
            label="选择学科"
            name="subjectId"
            rules={[{ required: true, message: "学科不可为空，请正确选择!" }]}
          >
            <Select
              placeholder="请选择学科"
              onChange={handleChange}
              allowClear
              style={{ width: 120 }}
            >
              {subjectIdArr.map((e: any, i: number) => {
                return (
                  <Option value={e.id} key={i}>
                    {e.name}
                  </Option>
                );
              })}
            </Select>
          </Form.Item>

          <Form.Item
            label="三级医院名称"
            name="name"
            rules={[
              { required: true, message: "医院名称不可为空，请正确选择!" },
            ]}
          >
            <AutoComplete
              options={options}
              // style={{ width: 200 }}
              onSelect={onSelect}
              onSearch={onSearch}
              placeholder="请输入医院名称"
            />
          </Form.Item>

          <Form.Item label="上传附件" valuePropName="files">
            <div key={fileKey}>
              <Upload
                listType="picture-card"
                maxCount={1}
                accept=".pdf"
                onRemove={(file) => {
                  const index = fileList.indexOf(file);
                  const newFileList = fileList.slice();
                  newFileList.splice(index, 1);
                  setFileList(newFileList);
                }}
                beforeUpload={(file) => {
                  console.log(file);
                  if (file.size > 307200) {
                    message.error("文件不可大于300K");
                    return;
                  }
                  const formData = new FormData();
                  formData.append("file", file);
                  setFileList([...fileList, file]);
                  const {
                    userInfo: { access_token },
                  } = store.getState();
                  const config = {
                    headers: {
                      "Content-Type": "multipart/form-data",
                      Authorization: `Bearer ${access_token}`,
                    },
                  };
                  axios
                    .post(
                      `/dev-api/file/oss/uploadFile?uploadFileType=file&folder=sys`,
                      formData,
                      config
                    )
                    .then(
                      (res: any) => {
                        console.log(res.data.data.shortUrl);
                        setShortUrl(res.data.data.shortUrl);
                      },
                      (err) => {
                        message.error(`${err}`);
                      }
                    );
                  return false;
                }}
              >
                <div>
                  <PlusOutlined />
                </div>
              </Upload>
            </div>
            <p style={{ color: "red" }}>
              {!!objItem.files ? "已有历史附件，再次上传可更改" : ""}
            </p>
            注：仅限上传pdf格式文件，大小不大于300k 。
          </Form.Item>

          <Form.Item wrapperCol={{ offset: 8, span: 16 }}>
            <Button
              style={{ marginRight: "15px" }}
              onClick={() => {
                setIsEditHelp(false);
              }}
            >
              取消
            </Button>
            <Button type="primary" htmlType="submit">
              保存
            </Button>
          </Form.Item>
        </Form>
      </Modal>

      <Modal
        title="解除帮扶关系"
        visible={isDelHelp}
        width={1000}
        onCancel={() => {
          setIsDelHelp(false);
        }}
        footer={[]}
      >
        <Table bordered columns={columnsDel} dataSource={dataDel} />

        <div>
          <Button
            type="primary"
            onClick={() => {
              setIsDelHelp(false);
            }}
          >
            取消
          </Button>
        </div>
      </Modal>
    </div>
  );
}

export default HelpRelation;
